/**
 *  @fileOverview Accordion module, initalises accordion instances
 *
 *  @author       Chris Hill
 *
 */

function AccordionModule () {
  /**
   * @description Initialises accordion instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    var nodes = document.querySelectorAll('.accordion')

    nodes.forEach((element, index) => {
      let strict

      /**
       * Check for strict accordion interpretation
       */
      if (typeof element.dataset.strict !== 'undefined') {
        strict = element.dataset.strict
      }

      /**
       * Apply event listeners to all accordion instance buttons
       */
      var btns = element.querySelectorAll('.accordion__title')
      btns.forEach((btn, i) => {
        btn.addEventListener('click', function () {
          /**
           * Get the next element after the button and toggle class and aria
           */
          let text = btn.nextElementSibling
          let aria = btn.getAttribute('aria-expanded')

          if (strict) {
            let isopen = btn.classList.contains('accordion__title--open')
            closeAll(element)

            /**
             * Only open if not already opened eg close on click
             */
            if (!isopen) {
              text.classList.toggle('accordion__body--open')
              btn.classList.toggle('accordion__title--open')
              btn.setAttribute('aria-expanded', aria === 'true' ? 'false' : 'true')
            }
          } else {
            text.classList.toggle('accordion__body--open')
            btn.classList.toggle('accordion__title--open')
            btn.setAttribute('aria-expanded', aria === 'true' ? 'false' : 'true')
          }
        })
      })
    })

    /**
     * @description Closes all accordion body elements
     *
     * @param {Object} accordion - Instance to apply to.
     *
     * @example
     * // returns NULL
     */
    function closeAll (accordion) {
      var items = accordion.querySelectorAll('.accordion__item')

      /**
       * Loop through accordion items and close them all
       */
      items.forEach((item) => {
        let btn = item.querySelector('.accordion__title')
        let body = item.querySelector('.accordion__body')

        btn.classList.remove('accordion__title--open')
        body.classList.remove('accordion__body--open')
      })
    }
  }
}

module.exports = AccordionModule
